import Navbar from "@/components/Navbar";
import SiteFooter from "@/components/public/SiteFooter";
import { useSite } from "@/context/SiteContext";
import { Hero, PartnersStrip, HowItWorks, Roles } from "@/components/landing/HeroSections";
import { Pricing, Testimonials, Faq, CtaBanner } from "@/components/landing/MoreSections";

const SECTIONS = { hero: Hero, partners: PartnersStrip, how: HowItWorks, roles: Roles, pricing: Pricing, testimonials: Testimonials, faq: Faq, cta: CtaBanner };

export default function Landing() {
  const { content: c } = useSite();

  if (!c)
    return (
      <div className="public-site min-h-screen bg-navy">
        <Navbar dark />
        <div className="mx-auto max-w-7xl px-5 py-32 text-white/40">Loading…</div>
      </div>
    );

  const visible = (c.sections || []).filter((s) => s.enabled && SECTIONS[s.id]);
  const startsDark = visible[0]?.id === "hero";

  return (
    <div className="public-site min-h-screen bg-white" data-testid="landing-page">
      <Navbar dark={startsDark} />
      {visible.map((s) => {
        const Comp = SECTIONS[s.id];
        return <Comp key={s.id} c={c} />;
      })}
      <SiteFooter />
    </div>
  );
}
